import PropTypes from 'prop-types';

import { ListingCostsShape } from '../../constants/shapes';

import OnBookingClosed from './OnBookingClosed';
import BeforeMoveIn from './BeforeMoveIn';
import BeforeMoveOut from './BeforeMoveOut';
import DuringStay from './DuringStay';
import ExtraServices from './ExtraServices';

import styles from './PaymentDetails.module.scss';

const PaymentDetails = ({
  listingCosts = {},
  pricing = {},
  downPaymentTimeInterval = undefined,
  isInstantBooking = false,
  hasNoDeposit = false,
  currencyIsoCode,
  contractDurationType = 'temporal'
}) => {
  const onCheckOutCosts = listingCosts?.onCheckOut;
  const onCheckOutCostList = onCheckOutCosts?.costs ?? [];
  const showBeforeMoveOut = onCheckOutCostList.length > 0;
  const extraCostList = listingCosts?.extra?.costs ?? [];
  const showExtraServices = extraCostList.length > 0;

  return (
    <div className={styles['payment-details']}>
      <OnBookingClosed
        currencyCode={currencyIsoCode}
        pricing={pricing}
        costs={listingCosts?.onBookingClosed}
        downPaymentTimeInterval={downPaymentTimeInterval}
        isInstantBooking={isInstantBooking}
      />
      <BeforeMoveIn
        currencyCode={currencyIsoCode}
        costs={listingCosts?.onCheckIn}
        hasNoDeposit={hasNoDeposit}
      />
      <hr className={styles['payment-details__divider']} />
      <DuringStay
        costs={listingCosts?.duringStay}
        currencyCode={currencyIsoCode}
        contractDurationType={contractDurationType}
      />
      {showBeforeMoveOut ? (
        <>
          <hr className={styles['payment-details__divider']} />
          <BeforeMoveOut
            costs={onCheckOutCosts}
            currencyCode={currencyIsoCode}
          />
        </>
      ) : null}
      {showExtraServices ? (
        <>
          <hr className={styles['payment-details__divider']} />
          <ExtraServices
            costs={listingCosts.extra}
            currencyCode={currencyIsoCode}
          />
        </>
      ) : null}
    </div>
  );
};

PaymentDetails.propTypes = {
  pricing: PropTypes.shape({
    currencyCode: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    totalContractValue: PropTypes.number
  }),
  listingCosts: PropTypes.shape({
    onBookingClosed: ListingCostsShape,
    onCheckIn: ListingCostsShape,
    duringStay: ListingCostsShape,
    onCheckOut: ListingCostsShape,
    extra: ListingCostsShape
  }),
  downPaymentTimeInterval: PropTypes.shape({
    type: PropTypes.oneOf(['months', 'weeks']),
    value: PropTypes.number
  }),
  isInstantBooking: PropTypes.bool,
  hasNoDeposit: PropTypes.bool,
  currencyIsoCode: PropTypes.string.isRequired,
  contractDurationType: PropTypes.string
};

export default PaymentDetails;
